import React, { useState, useEffect, useContext } from "react";
import BranchContext from "../context/branch";
import Select from "../common/select";
import {
  GetprivilegePage,
  getQueueActual,
  getWeightDetail,
  trucklistgroup,
  productgroup,
  getProductGroup,
} from "../../services/wms";
import moment from "moment";
import DatePicker from "react-datepicker";
import Header from "../common/headerlist";
import Renderdata from "./renderactual";
import ModalDetial from "./modalweightdetail";
// import Headerreport from "../wms/headerreport";
// import ReportCreate from "../chart/reportCreator";
import { toast } from "react-toastify";
// import {trucklistgroup,productgroup} from "../common/datalist";

const QueueMonitor = (props) => {
  const [ruckid, setruckid] = useState(0);
  const [id, setid] = useState(0);
  const [proid, setproid] = useState(0);
  const [queueid, setqueueid] = useState(0);
  const [startDate, setstartDate] = useState(new Date());
  const [productgrouplist, setproductgrouplist] = useState([]);
  const [queuelist, setqueuelist] = useState([]);
  const [currenttime, setcurrenttime] = useState("");
  const { currentBranch } = useContext(BranchContext);
  const [isOpen, setisOpen] = useState(false);
  // const [list, setlist] = useState([]);
  const [queuedetail, setqueuedetail] = useState([]);
  const [list, setlist] = useState([]);
  const [trucklist, settrucklist] = useState([]);

  const [onProgress, setonProgress] = useState(false);
  const [loading, setloading] = useState(false);
  const [ckPermit, setckPermit] = useState(false);

  const [total, settotal] = useState({
    all: 0,
    status1: 0,
    status2: 0,
    status3: 0,
    status4: 0,
    status5: 0,
    status6: 0,
  });

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;
    const loadPrivilege = async () => {
      const { data: result } = await GetprivilegePage(
        "/queueactual",
        currentBranch._id
      );
      if (result.status === "success") {
        setckPermit(true);
      } else if (result.status === "error") {
        setckPermit(false);
        toast.error(result.message);
      }
    };
    loadPrivilege();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;
    if (!ckPermit) return;
    setonProgress(true);
    const loadData = async () => {
      const { data: result } = await productgroup(currentBranch._id);
      if (result) {
        setonProgress(false);
        setlist(result);
      }
    };
    loadData();
  }, [currentBranch, ckPermit]);

  useEffect(() => {
    if (!currentBranch) return;
    if (
      currentBranch._id === "0" ||
      currentBranch._id === "" ||
      currentBranch._id !== "503"
    )
      if (!ckPermit) return;
    if (proid !== 5) return;

    setonProgress(true);
    const loadData = async () => {
      const { data: result } = await getProductGroup(currentBranch._id);
      if (result.status === "success") {
        setonProgress(false);
        setproductgrouplist(result.data.list);
      }
    };
    loadData();
  }, [currentBranch, ckPermit, proid]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;
    if (!ckPermit) return;
    setonProgress(true);
    const loadData = async () => {
      const { data: result } = await trucklistgroup(currentBranch._id);
      if (result) {
        setonProgress(false);
        settrucklist(result);
      }
    };
    loadData();
  }, [currentBranch, ckPermit]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;
    if (!ckPermit) return;
    setonProgress(true);
    const loadData = async () => {
      const { data: result } = await getWeightDetail(queueid);
      if (result) {
        setonProgress(false);
        setqueuedetail(result);
      }
    };
    loadData();
  }, [currentBranch, queueid, ckPermit]);

  useEffect(() => {
    if (!currentBranch) return;
    if (proid === 0) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;
    if (!ckPermit) return;

    setloading(true);
    const loadPrivilege = async () => {
      const { data: result } = await getQueueActual(
        currentBranch._id,
        moment(startDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
        proid,
        ruckid,
        id
      );
      if (result.status === "success") {
        setqueuelist(result.data.list);
        setcurrenttime(result.data.current);

        settotal({
          all:
            result.data.total.id1 +
            result.data.total.id2 +
            result.data.total.id3 +
            result.data.total.id4 +
            result.data.total.id5 +
            result.data.total.id6,
          status1: result.data.total.id1,
          status2: result.data.total.id2,
          status3: result.data.total.id3,
          status4: result.data.total.id4,
          status5: result.data.total.id5,
          status6: result.data.total.id6,
        });

        setloading(false);
      } else if (result.status === "error") {
        toast.error(result.message);
        setloading(false);
      }
    };
    loadPrivilege();
  }, [currentBranch, startDate, proid, id, ruckid, ckPermit]);

  const handleChange = ({ name, item, classname }) => {
    const clear = [...list];

    const index1 = clear.findIndex((x) => x.classname === "btn btn-primary");
    if (index1 > -1) {
      clear[index1].classname = "btn btn-outline-dark";
      setlist(clear);
    }
    const subobject = {
      _id: item,
      name: name,
      classname: "btn btn-primary",
    };
    const sub = [...list];
    const index = sub.findIndex((x) => x._id === item);
    sub[index] = subobject;
    setlist(sub);
    setproid(item);
  };

  const handleChangeTruck = ({ name, item, classname }) => {
    const clear = [...trucklist];

    const index1 = clear.findIndex((x) => x.classname === "btn btn-primary");
    if (index1 > -1) {
      clear[index1].classname = "btn btn-outline-dark";
      settrucklist(clear);
    }
    const subobject = {
      _id: item,
      name: name,
      classname: "btn btn-primary",
    };
    const sub = [...trucklist];
    const index = sub.findIndex((x) => x._id === item);
    sub[index] = subobject;
    settrucklist(sub);
    setruckid(item);
  };

  const handleChangStartDate = (event) => {
    setstartDate(event);
  };

  const handleConfirm = () => {
    setisOpen(false);
  };
  const handleCancel = () => {
    setisOpen(false);
  };

  const handleonClick = (id) => {
    setqueueid(id);
    setisOpen(true);
  };
  const handleChangeProduct = (event) => {
    setid(event.currentTarget.value);
  };

  if (!ckPermit) {
    // toast.error("ไม่พบสิทธิ์ในการเข้าถึง");
    return <></>;
  }

  return (
    <>
      <ModalDetial
        isOpen={isOpen}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        list={queuedetail}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-auto">
            <p>วันที่</p>

            <div className="mt-1" style={{ marginTop: 20, marginBottom: 20 }}>
              <DatePicker
                className="datepicker-default form-control"
                todayButton="Today"
                dateFormat="dd/MM/yyyy"
                selected={startDate}
                onChange={handleChangStartDate}
              />
            </div>
          </div>

          <div className="col-auto me-2">
            <p>กลุ่มสินค้า</p>
            <div className="m-1 " style={{ marginTop: 20, marginBottom: 20 }}>
              <Header list={list} onChange={handleChange} disabled={loading} />
            </div>
            {productgrouplist.length > 0 && proid === 5 ? (
              <div className="mb-2">
                <Select
                  options={productgrouplist}
                  label={"สินค้า"}
                  value={id}
                  onChange={handleChangeProduct}
                />
              </div>
            ) : null}
          </div>
          <div className="col-auto  ms-4">
            <p>กลุ่มรถบรรทุก</p>
            <div className="m-1 " style={{ marginTop: 20, marginBottom: 20 }}>
              <Header
                list={trucklist}
                onChange={handleChangeTruck}
                disabled={loading}
              />
            </div>
          </div>
        </div>

        <div className="row  mb-3">
          <div className="col-auto mb-2">
            <span
              className="badge bg-info text-dark"
              style={{ fontSize: "13px", cursor: "pointer" }}
            >
              {"รอชั่งออก"} {total.status1}
            </span>
          </div>
          <div className="col-auto mb-2">
            <span
              className="badge bg-success"
              style={{ fontSize: "13px", cursor: "pointer" }}
            >
              {"< 1.0 ชม.("} {total.status2}
              {" )"}
            </span>
          </div>
          <div className="col-auto mb-2">
            <span
              className="badge text-dark"
              style={{
                fontSize: "13px",
                backgroundColor: "#42f58d",
              }}
            >
              {"1 -1.5 ชม.("} {total.status3}
              {" )"}
            </span>
          </div>

          <div className="col-auto mb-2">
            <span
              className="badge text-dark"
              style={{
                fontSize: "13px",
                backgroundColor: "#fcf003",
              }}
            >
              {"1.5-2.0 ชม.("} {total.status4}
              {" )"}
            </span>
          </div>

          <div className="col-auto mb-2">
            <span
              className="badge badge text-dark"
              style={{
                fontSize: "13px",
                backgroundColor: "#fc6b03",
              }}
            >
              {">2.0 ชม.("} {total.status5} {")"}
            </span>
          </div>

          <div className="col-auto mb-2">
            <span
              className="badge  bg-primary"
              style={{ fontSize: "13px", cursor: "pointer" }}
            >
              {"Total"} {total.all}
            </span>
          </div>
        </div>

        <Renderdata
          list={queuelist}
          current={currenttime}
          handleonClick={handleonClick}
        />
      </div>
    </>
  );
};

export default QueueMonitor;
